import { Box } from '@theme-ui/components';
import styled from '@emotion/styled';

import { rem } from '@app/styles/theme/layout';

export const StockIndicatorWrapper = styled(Box)`
  margin-bottom: ${rem(30)};
  font-size: ${rem(15)};
`;
